import { CallIcon, DownloadIcon, EmailIcon } from "../../images/icons/icons";
import { EditIcon } from "../../images/icons/website-icons";
import { convertThenFormat } from "../common-data/Converts";
import { CSVLink } from "react-csv";

export const trainerTbColumns = (handleEdit, userInfoData) => {
  return [
 
    {
      dataField: "name",
      text: <p className="table__header">Trainer Details</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              width: "fit-content",
              gap: "4px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <b className="pb-1">{row?.name ? row?.name : "NA"}</b>
            <small
              style={{
                textTransform: "lowercase",
              }}
            >
              <EmailIcon />
              &nbsp;{row?.email ? row?.email : "NA"}
            </small>
            <small>
              <CallIcon />
              &nbsp;{row?.mobile ? row?.mobile : "NA"}
            </small>
            <small
              style={{
                fontSize: "12px",
                width: "200px",
              }}
            >
              {row?.address1}, {row?.city}, {row?.state}, {row?.pin},{" "}
              {row?.country}
            </small>
          </p>
        );
      },
    },
    {
      dataField: "trainer_exp_lvl_name",
      text: <p className="table__header">Trainer Experience Level</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text tb__exp"
            style={{
              textAlign: "center",
            }}
          >
            {row?.trainer_exp_lvl_name ? row?.trainer_exp_lvl_name : "NA"}
          </p>
        );
      },
    },
    {
      dataField: "non_recurring_unpaid",
      text: <p className="table__header">Gym Name</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              textAlign: "center",
            }}
          >
            {row?.gym_name ? row?.gym_name : "NA"}
          </p>
        );
      },
    },
    {
      dataField: "trainer_category",
      text: <p className="table__header">Trainer Category</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              textAlign: "center",
            }}
          >
            {row?.trainer_category ? row?.trainer_category : "NA"}
          </p>
        );
      },
    },
    {
      dataField: "date_onboarding",
      text: <p className="table__header">Date</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              textAlign: "center",
            }}
          >
            {`${row?.date_onboarding ? row?.date_onboarding : "NA"}`}
          </p>
        );
      },
    },
    {
      dataField: "aadhar_card",
      text: <p className="table__header">Adhar Card</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {row?.aadhar_card ? (
              <a
                href={row?.aadhar_card} // S3 link
                download // Enables direct download
                target="_blank" // Opens in a new tab (optional)
                rel="noopener noreferrer"
              >
                <DownloadIcon />
              </a>
            ) : (
              "NA"
            )}
          </p>
        );
      },
    },
    {
      dataField: "pan_card",
      text: <p className="table__header">Pan Card</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text"
            style={{
              textWrap: "wrap",
              textAlign: "center",
            }}
          >
            {row?.pan_card ? (
              <a
                href={row?.pan_card} // S3 link
                download // Enables direct download
                target="_blank" // Opens in a new tab (optional)
                rel="noopener noreferrer"
              >
                <DownloadIcon />
              </a>
            ) : (
              "NA"
            )}
          </p>
        );
      },
    },
    {
      dataField: "status",
      text: <p className="table__header">Status</p>,
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data table__Text tb__status"
            style={{
              textWrap: "wrap",
              color: "#fff",
            }}
          >
            {row?.status ? row?.status : "NA"}
          </p>
        );
      },
    },
    userInfoData?.account_type === "admin" && {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => handleEdit(row)}
          >
            <EditIcon />
          </button>
        </div>
      ),
    },
  ];
};

export const getCSVData = (trainerData) => {
  return trainerData?.data?.length > 0
    ? trainerData.data.map((row) => ({
        Name: row?.name || "NA",
        Email: row?.email || "NA",
        Mobile: row?.mobile || "NA",
        Gym: row?.gym_name || "NA",
        Category: row?.trainer_category || "NA",
        OnboardingDate: row?.date_onboarding || "NA",
        Status: row?.status || "NA",
      }))
    : [];
};

export const ExportCSVButton = ({ trainerData }) => {
  return (
    <CSVLink
      data={getCSVData(trainerData)}
      filename="trainers.csv"
      className="btn-k red-bg-k decoration-none-k"
      target="_blank"
    >
      Export CSV
    </CSVLink>
  );
};
